import React from "react";
import { Box, Skeleton } from "@mui/material";
import {
  dashboard2TodayStatusHeadlineSx,
  dashboard2WeekPlanIntroSx,
  dashboard2WeekPlanningGridFillSx,
  dashboard2WeekPlanningMobileDaySx
} from "../dashboard2-status.styles";
import {
  dashboard2TodayColleagueIdentityRowSx,
  dashboard2TodayColleagueRowSx,
  dashboard2TodayStripSx
} from "../dashboard2.styles";
import { DASHBOARD2_WORKDAY_COUNT } from "../utils/dashboard2-schedule.utils";

export const Dashboard2TodayStatusStripLoading: React.FC = () => (
  <Box sx={dashboard2TodayStripSx} data-testid="dashboard2-today-status-strip-loading">
    <Skeleton variant="text" width="40%" height={20} />
    <Box sx={dashboard2TodayStatusHeadlineSx}>
      <Skeleton variant="circular" width={32} height={32} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Skeleton variant="text" width="72%" height={24} />
        <Skeleton variant="text" width="48%" height={20} />
        <Skeleton variant="text" width="36%" height={18} />
      </Box>
    </Box>
    <Skeleton variant="rounded" width={88} height={24} />
  </Box>
);

type Dashboard2TodayColleaguesStripLoadingProps = {
  rowCount?: number;
};

export const Dashboard2TodayColleaguesStripLoading: React.FC<
  Dashboard2TodayColleaguesStripLoadingProps
> = ({ rowCount = 2 }) => (
  <Box sx={dashboard2TodayStripSx} data-testid="dashboard2-today-colleagues-strip-loading">
    {Array.from({ length: rowCount }, (_, index) => (
      <Box key={`loading-colleague-row-${index}`} sx={dashboard2TodayColleagueRowSx}>
        <Box sx={dashboard2TodayColleagueIdentityRowSx}>
          <Skeleton variant="circular" width={24} height={24} />
          <Skeleton variant="text" sx={{ flex: 1 }} height={22} />
          <Skeleton variant="text" width={72} height={22} />
        </Box>
        <Skeleton variant="text" width="68%" height={18} sx={{ pl: 3.75 }} />
      </Box>
    ))}
  </Box>
);

export const Dashboard2WeekPlanIntroLoading: React.FC = () => (
  <Box sx={dashboard2WeekPlanIntroSx} data-testid="dashboard2-week-plan-intro-loading">
    <Skeleton variant="text" width="32%" height={28} />
    <Skeleton variant="text" width="88%" height={20} />
    <Skeleton variant="rounded" height={6} />
  </Box>
);

type Dashboard2WeekPlanningDaysLoadingProps = {
  isCompactViewport: boolean;
  workDayCount?: number;
};

export const Dashboard2WeekPlanningDaysLoading: React.FC<
  Dashboard2WeekPlanningDaysLoadingProps
> = ({ isCompactViewport, workDayCount = DASHBOARD2_WORKDAY_COUNT }) => (
  <Box sx={dashboard2WeekPlanningGridFillSx(isCompactViewport, workDayCount)}>
    {Array.from({ length: workDayCount }, (_, index) => {
      const dayKey = `loading-day-${index}`;

      if (isCompactViewport) {
        return (
          <Box key={dayKey} sx={dashboard2WeekPlanningMobileDaySx}>
            <Skeleton
              variant="rounded"
              sx={{ height: "100%", minHeight: 120 }}
              data-testid="dashboard2-week-planning-day-skeleton"
            />
          </Box>
        );
      }

      return (
        <Skeleton
          key={dayKey}
          variant="rounded"
          sx={{ height: "100%", minHeight: 120 }}
          data-testid="dashboard2-week-planning-day-skeleton"
        />
      );
    })}
  </Box>
);
